var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { isNumber } from '../utils';
import { BadgeContent } from '../BadgeContent';
import "./styles.css";
export var CounterBody = forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, count = _a.count, warning = _a.warning, hideBadgeContent = _a.hideBadgeContent, error = _a.error, rest = __rest(_a, ["children", "className", "count", "warning", "hideBadgeContent", "error"]);
    var rootClassName = classNames('lk-ui-counter-root', className);
    return (React.createElement("div", __assign({}, rest, { className: rootClassName, ref: ref }),
        children,
        (isNumber(count) || warning) && (React.createElement(BadgeContent, { count: count, error: error, warning: warning, hideBadgeContent: hideBadgeContent }))));
});
